import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MenuPortal } from "shared/components/menu/MenuPortal";
import { MoreHorizontalIcon } from "shared/icons/MoreHorizontalIcon";

export const MaybernTableRowMenu: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslation(["common"]);
  const { isOpen, onToggle, onClose } = useDisclosure();
  return (
    <Menu
      offset={[0, 0]}
      isOpen={isOpen}
      onClose={onClose}
      isLazy={true}
      lazyBehavior="unmount"
    >
      <MenuButton
        as={IconButton}
        variant="ghost"
        size="tablerow-icon"
        aria-label={t("common:options")}
        icon={<MoreHorizontalIcon color="gray.400" />}
        onClick={onToggle}
      />
      <MenuPortal>
        <MenuList>{children}</MenuList>
      </MenuPortal>
    </Menu>
  );
};
